export const config = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || "http://localhost:3000/api",
  endpoints: {
    login: "/auth/login",
    register: "/auth/register",
    forgotPassword: "/auth/forgotPassword",
    verifyCode: "/auth/verifyCode",
    setPassword: "/auth/setPassword",
    walletBalance: "/wallet/balance/",
    NINVerify: "/verify/nin",
    BVNVerify: "/verify/bvn",
    VerificationHistory: "/transactions/history/",
    DataHistory: "/transactions/dataHistory/",
    setPin: "/wallet/set-pin/",
    ResetPin: "/wallet/change-pin/",
    dataSubscription: "/vtu/data",
    airtimeSubscription: "/vtu/airtime",
    subscriptionHistory: "/transactions/history/",
    ipeSubmit: "/verify/submit/ipe",
    checkStatusipe: "/verify/freeStatus/ipe",
    freeStatusipe: "/verify/freeStatus/ipe",
    cacRegistration: "/cac/register",
    bankAgentRegistration: "/bvn/register",
    bvnLicenceRegistration: "/bvnuser/submit",
    bvnLicenceHistory: "/bvnuser/user/",
    Modification: "/modify/register",
    Personalisation: "/personalization/register",
    personalisationHistory: "/personalization/",
    DemographicSearch: "/demographic/register",
    DemographicSearchHistory: "/demographic/",
    Enrollment: "/enrollment/register",
    apitoken: "/developer/tokens",
    currentapipricing: "/transactions/prices",
    Validation: "/nin/validate",
    getCAC: "/cac/",
    validationHistory: "/nin/",
    initiateTopup: "/wallet/topup/initiate/",
    userIntro: "message",
    BVNModification: "/bvnModification",
    BVNModificationHistory: "/bvnModification/my-submissions/",
    CreatePlan: "/data-plan",
    getPlans: "/data-plans/",
    deletePlan: "/data-plan/",
    updatePlan: "/data-plan/",
    VTUTransactionHistory: "/vtu/transactions/",
    BasicNINVerification: "/verify/preambly/nin",
    ApiUserDashboardInfo: "/apiuser/dashboard/basic-info",
    ApiUserDashboardWallet: "/apiuser/dashboard/wallet",
    ApiUserDashboardTransactions: "/apiuser/dashboard/transactions",
    ApiUserSalesVolume: "/apiuser/dashboard/sales-volume",
    ApiUserTargets: "/apiuser/dashboard/api-targets",
    ApiUserPerformance: "/apiuser/dashboard/performance",
    userProfile: "/user/profile/",
    managerLogin: "/task/manager/login",
    managerProfile: "/task/manager/profile",
    managerChangePassword: "/task/manager/change-password",
    managerPerformance: "/task/manager/performance",
    modificationHistory: "/modify/my-submissions/",
    bvnCrm: "/bvncrm/create",
    bvnCrmHistory: "/bvncrm/user/",
    bvnCrmTicket: "/bvncrm/ticket/",
    bvnManualWithPhone: "/verify/bvn/manual-with-phone",
    getNotifications: "/notifications/",
    readNotification: "/notifications/"
  },
}
